import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { GraduationCap, Plus, Trash2 } from 'lucide-react';
import { FieldError, SectionHeader, dangerButton, inputClass, profileCard, subtleButton } from './ProfileUI';

const emptyEducation = {
  institution: '',
  degree: '',
  field_of_study: '',
  start_year: '',
  end_year: '',
};

const EducationSection = ({ education, onChange, errors = [] }) => {
  const updateEntry = (index, field, value) => {
    onChange(education.map((entry, entryIndex) => (entryIndex === index ? { ...entry, [field]: value } : entry)));
  };

  const addEntry = () => {
    onChange([...education, { ...emptyEducation }]);
  };

  const removeEntry = (index) => {
    onChange(education.filter((_, entryIndex) => entryIndex !== index));
  };

  return (
    <section className={profileCard}>
      <SectionHeader
        icon={GraduationCap}
        eyebrow="Step 03"
        title="Education timeline"
        action={
          <button type="button" onClick={addEntry} className={subtleButton}>
          <Plus className="h-4 w-4" />
          Add
        </button>
        }
      />
      <div className="mt-4 space-y-4">
        <AnimatePresence initial={false}>
          {education.map((entry, index) => (
          <motion.div
            key={index}
            layout
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            className="relative rounded-2xl border border-slate-700/50 bg-slate-900/50 p-4 transition hover:border-purple-400/50 hover:shadow-lg hover:shadow-purple-500/10"
          >
            <div className="absolute left-4 top-4 hidden h-[calc(100%-2rem)] w-px bg-gradient-to-b from-purple-400/70 to-pink-500/10 sm:block" />
            <div className="grid gap-3 sm:pl-8 md:grid-cols-2">
              <input className={inputClass} placeholder="Institution" value={entry.institution} onChange={(event) => updateEntry(index, 'institution', event.target.value)} />
              <input className={inputClass} placeholder="Degree" value={entry.degree} onChange={(event) => updateEntry(index, 'degree', event.target.value)} />
              <input className={inputClass} placeholder="Field of study" value={entry.field_of_study || ''} onChange={(event) => updateEntry(index, 'field_of_study', event.target.value)} />
              <div className="grid grid-cols-2 gap-3">
                <input className={inputClass} placeholder="Start year" value={entry.start_year || ''} onChange={(event) => updateEntry(index, 'start_year', event.target.value)} />
                <input className={inputClass} placeholder="End year" value={entry.end_year || ''} onChange={(event) => updateEntry(index, 'end_year', event.target.value)} />
              </div>
            </div>
            <div className="sm:pl-8">
              <FieldError>{errors[index]}</FieldError>
            </div>
            <button type="button" onClick={() => removeEntry(index)} className={`${dangerButton} mt-3 sm:ml-8`}>
              <Trash2 className="h-4 w-4" />
              Remove
            </button>
          </motion.div>
          ))}
        </AnimatePresence>
        {!education.length && (
          <div className="rounded-2xl border border-dashed border-white/15 bg-slate-950/30 p-6 text-center text-sm text-slate-400">
            Add schools, degrees, or certifications to complete your career context.
          </div>
        )}
      </div>
    </section>
  );
};

export default EducationSection;
